function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1280 768c0-282.77-229.23-512-512-512S256 485.23 256 768c0 255.554 187.231 467.37 432 505.78V916H558V768h130V655.2C688 526.88 764.438 456 881.39 456 937.407 456 996 466 996 466v126h-64.562C867.835 592 848 631.467 848 671.957V768h142l-22.7 148H848v357.78c244.769-38.41 432-250.226 432-505.78",
  fill: "#FFF"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M967.3 916L990 768H848v-96.043c0-40.49 19.835-79.957 83.438-79.957H996V466s-58.593-10-114.61-10C764.438 456 688 526.88 688 655.2V768H558v148h130v357.78c26.067 4.09 52.784 6.22 80 6.22s53.933-2.13 80-6.22V916h119.3",
  fill: "transparent"
});

var SvgFacebook = function SvgFacebook(props) {
  return React.createElement("svg", _extends({
    viewBox: "256 256 1024 1024"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjI1NiAyNTYgMTAyNCAxMDI0Ij48cGF0aCBkPSJNMTI4MCA3NjhjMC0yODIuNzctMjI5LjIzLTUxMi01MTItNTEyUzI1NiA0ODUuMjMgMjU2IDc2OGMwIDI1NS41NTQgMTg3LjIzMSA0NjcuMzY5OSA0MzIgNTA1Ljc4MDA4VjkxNkg1NThWNzY4aDEzMFY2NTUuMkM2ODggNTI2Ljg4IDc2NC40MzggNDU2IDg4MS4zOSA0NTYgOTM3LjQwNyA0NTYgOTk2IDQ2NiA5OTYgNDY2djEyNmgtNjQuNTYyQzg2Ny44MzUgNTkyIDg0OCA2MzEuNDY3IDg0OCA2NzEuOTU3Vjc2OGgxNDJsLTIyLjcgMTQ4SDg0OHYzNTcuNzgwMDhDMTA5Mi43NjkgMTIzNS4zNjk5IDEyODAgMTAyMy41NTQgMTI4MCA3NjgiIGZpbGw9IiNGRkYiLz48cGF0aCBkPSJNOTY3LjMgOTE2TDk5MCA3NjhIODQ4di05Ni4wNDNjMC00MC40OSAxOS44MzUtNzkuOTU3IDgzLjQzOC03OS45NTdIOTk2VjQ2NnMtNTguNTkzLTEwLTExNC42MS0xMEM3NjQuNDM4IDQ1NiA2ODggNTI2Ljg4IDY4OCA2NTUuMlY3NjhINTU4djE0OGgxMzB2MzU3Ljc4MDA4YzI2LjA2NyA0LjA4OTg0IDUyLjc4NCA2LjIxOTkyIDgwIDYuMjE5OTJzNTMuOTMzLTIuMTMwMDggODAtNi4yMTk5MlY5MTZoMTE5LjMiIGZpbGw9InRyYW5zcGFyZW50Ii8+PC9zdmc+";
export { SvgFacebook as ReactComponent };